<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="images/logo.png" alt="">
      </div>
      <div class="name-box">韦氏幼儿智力量表第四版中文版统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="images/input-header-icon.png" alt=""><span class="name">适用年龄（2:6 - 3:11）</span></div>
      </div>
      <div class="body">
        <div class="de" style="margin:0 0 40px 0;font-size: 14px"><span style="color: #832C75;font-weight: bold;margin-right: 10px">原始数据</span>ps: <span style="color: #832C75">*</span>为必填项</div>
        <a-form-model ref="form" :model="formModel" :rules="formRules" autoComplete="off" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left">
          <a-row>
              <a-col :span="11">
                <a-form-model-item label="测试日期" prop="children.test_date">
                  <a-date-picker :disabled="id ? true : false" style="width: 100%" class="cu-input1" @change="changeParentTestTime" format="YYYY-MM-DD" v-model="formModel.children.test_date"/>
                </a-form-model-item>
              </a-col>
          </a-row>
          <a-row>
              <a-col :span="11">
                <a-form-model-item label="实际年龄" prop="children.real_age">
                  <a-input class="cu-input1" disabled placeholder="选择测试日期后将自动计算" v-model="formModel.children.real_age"/>
                </a-form-model-item>
              </a-col>
          </a-row>
          <div class="line1"></div>
          <div v-if="detailScoreAvailable || existingDetailed" class="detail-score-switch">
            <div>
              <div class="detail-score-switch-title">详细分数录入</div>
              <div class="detail-score-switch-state">{{ detailScoreMode ? '已开启' : '手工录入' }}</div>
            </div>
            <a-switch
              :checked="detailScoreMode"
              :disabled="existingDetailed && !detailScoreAvailable"
              @change="handleDetailScoreModeChange"
            />
          </div>
          <wisc-score-detail
            v-if="detailScoreMode"
            v-model="formModel.children.detail_scores"
            @totals-change="applyDetailTotals"
          />
          <a-row>
            <a-col :span="11">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="指认图片" prop="children.score_rv">
                    <div class="flex">
                      <a-input-number @focus="numFocus" v-model="formModel.children.score_rv" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="31"/>
                      <span class="num-de"><0-31></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="积木" prop="children.score_bd">
                    <div class="flex">
                      <a-input-number @focus="numFocus" v-model="formModel.children.score_bd" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="34"/>
                      <span class="num-de"><0-34></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="图片记忆" prop="children.score_pm">
                    <div class="flex">
                      <a-input-number @focus="numFocus" v-model="formModel.children.score_pm" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="35"/>
                      <span class="num-de"><0-35></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="常识" prop="children.score_in">
                    <div class="flex">
                      <a-input-number @focus="numFocus" v-model="formModel.children.score_in" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="29"/>
                      <span class="num-de"><0-29></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="拼图" prop="children.score_oa">
                    <div class="flex">
                      <a-input-number @focus="numFocus" v-model="formModel.children.score_oa" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="32"/>
                      <span class="num-de"><0-32></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="动物家园" prop="children.score_zl">
                    <div class="flex">
                      <a-input-number @focus="numFocus" v-model="formModel.children.score_zl" :disabled="detailScoreMode" class="cu-input1 input-number-100" :min="0" :max="20"/>
                      <span class="num-de"><0-20></span></div>
                  </a-form-model-item>
                  <a-form-model-item label="图片命名" prop="children.score_pn">
                    <div class="flex">
                      <a-input-number @focus="numFocus" class="cu-input1 input-number-100" :disabled="detailScoreMode" :min="0" :max="24" v-model="formModel.children.score_pn"/>
                      <span class="num-de"><0-24></span></div>
                  </a-form-model-item>

                </a-col>
              </a-row>
            </a-col>
            <a-col :span="11" class="right-box" style="padding-left: 40px">
              <a-row>
                <a-col>
                  <div class="right-title">比较类型</div>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="置信区间" prop="children.confidence_probability">
                    <a-select v-model="formModel.children.confidence_probability" placeholder="请选择" style="width: 260px;" dropdownClassName="cu-select">
                      <a-select-option value="90">90%</a-select-option>
                      <a-select-option value="95">95%</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="统计显著性水平" prop="children.significance_level">
                    <a-select v-model="formModel.children.significance_level" placeholder="请选择(强项/弱项)" style="width: 260px" dropdownClassName="cu-select">
                      <a-select-option value="0.05">0.05</a-select-option>
                      <a-select-option value="0.15">0.15</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="比较基础" prop="children.comparison_basis">
                    <a-select v-model="formModel.children.comparison_basis" placeholder="请选择比较基础" style="width: 260px" dropdownClassName="cu-select">
                      <a-select-option value="1">全样本</a-select-option>
                      <a-select-option value="2">能力水平</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <div style="font-size: 12px;color: #832C75;margin-bottom: 20px;padding-left: 5px">存在无效的原始分数时</div>
                  <a-form-model-item label="计算方法" prop="children.computing_method">
                    <a-radio-group name="radioGroup" v-model="formModel.children.computing_method">
                      <a-radio :value="1">替代分测验</a-radio>
                      <a-radio :value="2">比例估算法</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <div style="display: flex;align-items: center;justify-content: center">
<!--            <div class="btn sh" @click="goSelectAge"><img src="images/btn-left-icon.png" alt="" style="height: 12px;margin-right: 5px"><span>返回选择页面</span></div>-->
            <div class="btn" @click="actionData">{{ id != '' ? '编辑并生成报告' : '保存并生成报告' }}</div>

          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import {Save, Detail, Update, GetDetailScoreFeature} from '../../commonApi';
import {base, children, childrenRule} from "../children-field";
import {message} from "ant-design-vue";
import * as Api from "../base-info/api";
import moment from "moment";
import WiscScoreDetail from "../../components/wisc-score-detail";

export default {
  components: {WiscScoreDetail},
  data() {
    return {
      labelCol: {span: 8, style: {color: '#7E8589', fontWeight: '500'}},
      wrapperCol: {span: 14},
      formModel: {
        base: Object.assign({}, base),
        children: Object.assign({}, children),
      },
      formRules: Object.assign({}, {...childrenRule}),
      isUnit: 1, // 是否关联
      bindListVisible: false,
      id: '',
      source: '',
      detailScoreAvailable: false,
      detailScoreMode: false,
      existingDetailed: false,
    }
  },
  mounted() {
    this.loadDetailScoreFeature();
    // 编辑
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.source = this.$route.query.source;
      this.getDetail()
    } else {
      this.formModel.base = JSON.parse(window.localStorage.getItem('base_info'));
    }
  },
  methods: {
    async getDetail() {
      const res = await Detail({id: this.id});
      if (res && res.code == 0) {
        const detailScoreMode = String(res.wiscAssessment.detail_score_enabled) === '1';
        this.detailScoreMode = detailScoreMode;
        this.existingDetailed = detailScoreMode;
        this.formModel.children = Object.assign({}, children, res.wiscAssessment, {
          detail_scores: res.wiscAssessment.detail_scores || {},
        });
        this.formModel.base = {
            id:res.wiscAssessment.id,
            archives_num: res.wiscAssessment.archives_num,
            scoring_num: res.wiscAssessment.scoring_num,
            name: res.wiscAssessment.name,
            examiner_name: res.wiscAssessment.examiner_name,
            gender: res.wiscAssessment.gender,
            is_minorities : res.wiscAssessment.is_minorities,
            hand_habit: res.wiscAssessment.hand_habit,
            exam_address: res.wiscAssessment.exam_address,
            born_date : res.wiscAssessment.born_date,
            remark: res.wiscAssessment.remark,
            grade: res.wiscAssessment.grade,
            parent_culture: res.wiscAssessment.parent_culture,
          }
          this.formModel.children.computing_method = parseInt(this.formModel.children.computing_method)
      }
    },
    async loadDetailScoreFeature() {
      const res = await GetDetailScoreFeature();
      if (res && res.code == 0) {
        this.detailScoreAvailable = Boolean(res.enabled);
      }
    },
    handleDetailScoreModeChange(checked) {
      this.detailScoreMode = checked;
      this.formModel.children.detail_score_enabled = checked ? '1' : '0';
    },
    applyDetailTotals(totals) {
      if (!this.detailScoreMode) return;
      Object.keys(totals).forEach((key) => {
        this.$set(this.formModel.children, key, totals[key]);
      });
    },
    goSelectAge() {
      this.$router.push({path: '/select-age'})
    },
    changeBornTimeParent(e, s) {
      if (s) {
        this.formModel.parent.test_date = s;
      } else {
        this.formModel.parent.test_date = ''
      }
    },
    changeBornTimeTeacher(e, s) {
      if (s) {
        this.formModel.teacher.test_date = s;
      } else {
        this.formModel.teacher.test_date = ''
      }
    },
    numFocus() {
      this.$refs["form"].clearValidate('children.computing_method');
      this.formRules['children.computing_method'][0]['required'] = false;

    },
    changeComputingMethod() {
      if (/^[0-9]+$/.test(this.formModel.children.score_rv)
          && /^[0-9]+$/.test(this.formModel.children.score_bd)
          && /^[0-9]+$/.test(this.formModel.children.score_pm)
          && /^[0-9]+$/.test(this.formModel.children.score_in)
          && /^[0-9]+$/.test(this.formModel.children.score_oa)
          && /^[0-9]+$/.test(this.formModel.children.score_zl)
          && /^[0-9]+$/.test(this.formModel.children.score_pn)) {
        this.formModel.children.computing_method = undefined;
      }
    },
    async actionData() {
      this.formModel.children.detail_score_enabled = this.detailScoreMode ? '1' : '0';
      // this.changeComputingMethod();
      // if (!this.formModel.children.score_rv) {
      //   if (this.formModel.children.score_rv != '0') {
      //     this.formRules['children.computing_method'][0]['required'] = true;
      //
      //   }
      // }
      // if (!this.formModel.children.score_bd) {
      //   if (this.formModel.children.score_bd != '0') {
      //     this.formRules['children.computing_method'][0]['required'] = true;
      //
      //   }
      // }
      // if (!this.formModel.children.score_pm) {
      //   if (this.formModel.children.score_pm != '0') {
      //     this.formRules['children.computing_method'][0]['required'] = true;
      //
      //   }
      // }
      // if (!this.formModel.children.score_in) {
      //   if (this.formModel.children.score_in != '0') {
      //     this.formRules['children.computing_method'][0]['required'] = true;
      //
      //   }
      // }
      // if (!this.formModel.children.score_oa) {
      //   if (this.formModel.children.score_oa != '0') {
      //     this.formRules['children.computing_method'][0]['required'] = true;
      //
      //   }
      // }
      // if (!this.formModel.children.score_zl) {
      //   if (this.formModel.children.score_zl != '0') {
      //     this.formRules['children.computing_method'][0]['required'] = true;
      //
      //   }
      // }
      // if (!this.formModel.children.score_pn) {
      //   if (this.formModel.children.score_pn != '0') {
      //     this.formRules['children.computing_method'][0]['required'] = true;
      //
      //   }
      // }


      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.isUnit == 1) {
            this.formModel.teacher = {};
          }
          let res = null;

          if (this.id) {
            res  = await Update({base: this.formModel.base, assessment: this.formModel.children});
          } else {
            res  = await Save({base: this.formModel.base, assessment: this.formModel.children});
          }
          if (res && res.code == 0) {
            window.localStorage.removeItem('base_info');
            message.success({ content: res.message});
            setTimeout(()=> {
              if (this.id == '') {
                this.$router.push({ path: "/" });
              }
              else if (this.id != '' && this.source == 'index') {
                this.$router.push({ path: "/" });
              }
              else if (this.id != '' && this.source == 'history') {
                this.$router.push({ path: "/maintain-history-report" });
              }

            }, 1500);
          }
        } else {
          message.error({ content: '表单验证未通过'});
        }
      });
    },
    openBindList() {
      this.bindListVisible = true;
    },
    changeBindList(e) {
      if (e.type == 'cancel') {
        this.bindListVisible = false;
      } else if (e.type == 'select') {
        this.bindListVisible = false;
        this.formModel.teacher = Object.assign({}, e.data);
      }
    },
    async getRealAge(type, time) {
      const res = await Api.GetRealAge({born_time: this.formModel.base.born_date, test_date: time});
      if (res && res.code == 0) {
        this.formModel.children.real_age = res.realAge;
      }
    },
    changeTeachTestTime(e,s) {
      if (s) {
        this.formModel.children.test_date = s;
        this.getRealAge('teacher', s);
      }
      else {
        this.formModel.children.real_age = ''
      }
    },
    changeParentTestTime(e,s) {
      if (s) {
        this.formModel.children.test_date = s;
        this.getRealAge('parent', s);
      }
      else {
        this.formModel.children.real_age = ''
      }
    }
  }
};
</script>
<style>

</style>
<style scoped>
.main-body {
  background-image: var(--wisc-image-maintain-bg);
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.detail-score-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
  padding: 14px 18px;
  border: 1px solid #eadfea;
  border-radius: 5px;
  background: #faf7fa;
}

.detail-score-switch-title {
  color: #832c75;
  font-size: 14px;
  font-weight: 600;
}

.detail-score-switch-state {
  margin-top: 3px;
  color: #999;
  font-size: 12px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}
.flex {
  display: flex;
}
.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  //height: 460px;
  border-left: 1px solid #eee;
  padding-left: 70px;
  justify-content: center;
}
.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #832C75;
  margin-bottom: 20px;
}
.cu-select{
  line-height: 42px;
  height: 42px;
}
.btn {
  background: #832C75;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 80px;
}
.btn.sh {
  border: 1px solid #832B75;
  border-radius: 5px;
  font-weight: 400;
  color: #832B75;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}
.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
